export default {
  BASE_DEV_ROUTE: 'http://localhost:3000/service',
  BASE_STAGING_ROUTE: 'http://staging-dtn.vidax.com/service',
  BASE_PROD_ROUTE: '/service', // https://desidmc.com/service',

  KEY_CODE: {
    ESC: 27,
  },

  PHOTOS: {
    origin: 'photoOriginal',
    medium: 'photoMedium',
    small: 'photoSmall',
    extraSmall: 'photoExtraSmall'
  },

  MAP: {
    KEY: 'AIzaSyAXld6Rao1mspTYI1rJd5NOoyr_tfKcU8E',
    DEFAULT_CORDS: {
      lat: 38.9071923,
      lng: -77.0368707
    },
    DEFAULT_ZOOM: 8
  }
};



// WEBPACK FOOTER //
// ./src/app/config/const.js